/**
 * tailwind plugins was written using extend configuration feature. It was used to give our modal sizes into the existing config.

 * ? https://tailwindcss.com/docs/plugins#extending-the-configuration
 */
import plugin from 'tailwindcss/plugin'

export default plugin(
  ({ matchUtilities, theme }) => {
    matchUtilities(
      {
        body: (value) => ({
          fontSize: value[0],
          lineHeight: value[1],
          fontWeight: value[2],
          letterSpacing: value[3],
        }),
      },
      { values: theme('body') },
    )
  },
  {
    theme: {
      body: {
        1: ['1rem', '1.5rem', 500, 0],
        2: ['0.875rem', '1.25rem', 500, 0],
        3: ['0.75rem', '1rem', 500, 0],
      },
    },
  },
)
